import React from 'react';
import { useLocation } from 'react-router-dom';
import { ShortlistBar, ShortlistModal } from '../features/shortlist';
import { useShortlistContext } from '../contexts/ShortlistContext';

const GlobalShortlist: React.FC = () => {
  const location = useLocation();
  const {
    shortlistItems,
    removeFromShortlist,
    isModalOpen,
    openModal,
    closeModal,
    submitQuoteRequest,
    isSubmitting,
  } = useShortlistContext();

  // Don't show shortlist on shortlists routes or admin page
  const isShortlistRoute = location.pathname.startsWith('/shortlists');
  const isAdminRoute = location.pathname.startsWith('/admin');
  if (isShortlistRoute || isAdminRoute) {
    return null;
  }

  return (
    <>
      {/* Shortlist Bar */}
      <ShortlistBar
        shortlistedProfiles={shortlistItems}
        onRemoveFromShortlist={removeFromShortlist}
        onViewShortlist={openModal}
      />

      {/* Shortlist Modal */}
      <ShortlistModal
        isOpen={isModalOpen}
        onClose={closeModal}
        shortlistedProfiles={shortlistItems}
        onRemoveFromShortlist={removeFromShortlist}
        onSubmitQuote={submitQuoteRequest}
        loading={isSubmitting}
      />
    </>
  );
};

export default GlobalShortlist;
